import Phaser from 'phaser';
import { COLORS, SCREEN } from '../config/theme.js';
import { session } from '../state/session.js';
import { loadSavedSession, forgetRoom } from '../state/persist.js';
import { joinGameByCode } from '../net/client.js';

/**
 * Boot scene — waits for the Fredoka web font to load (so the parchment UI
 * renders with the right type from the first frame, matching the prototype),
 * then routes the player. If the browser remembers a room (they were in a lobby
 * last visit and didn't explicitly Leave), it re-joins that room and drops them
 * straight into the Lobby; otherwise it hands off to the Splash screen. No
 * visible UI of its own beyond the meadow-sky background.
 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super('Boot');
  }

  create(): void {
    const done = async (): Promise<void> => {
      // `loadSavedSession` also hydrates `session.player` (remembered identity).
      const room = loadSavedSession();
      if (room) {
        try {
          await joinGameByCode(room.code, session.player, room.password);
          session.room = { code: room.code, name: room.name };
          this.scene.start('Lobby');
          return;
        } catch {
          // Room is gone / full / already started — drop the stale memory, go home.
          forgetRoom();
        }
      }
      this.scene.start('Splash');
    };
    // `document.fonts.ready` resolves once webfonts are loaded; guard for safety.
    if (typeof document !== 'undefined' && document.fonts?.ready) {
      void document.fonts.ready.then(done).catch(done);
    } else {
      void done();
    }
  }
}

export const SCENE_BACKGROUND = COLORS.meadow;
export const GAME_SIZE = SCREEN;
